import React from 'react';

import styled from 'styled-components';

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 3.53125rem 0;

  border-bottom: 1px solid rgb(137, 108, 108, 0.1);

  > * {
    flex-basis: ${props => 100 / React.Children.count(props.children)}%;
  }

  :first-child {
    padding-top: 3rem;
  }

  :last-child {
    padding: 0;
    border-bottom: none;
  }
`;
